{
	"Subtype_Desert": "Desert",
	"Subtype_Forest": "Forest",
	"Subtype_Gate": "Gate",
	"Subtype_Island": "Island",
	"Subtype_Lair": "Lair",
	"Subtype_Locus": "Locus",
	"Subtype_Mine": "Mine",
	"Subtype_Mountain": "Mountain",
	"Subtype_Plains": "Plains",
	"Subtype_Power-Plant": "Power-Plant",
	"Subtype_Sphere": "Sphere",
	"Subtype_Swamp": "Swamp",
	"Subtype_Tower": "Tower",
	"Subtype_Urza's": "Urza's"
}